import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_55: FaireProductEntity = {
  token: "legacy_prod_abbott-55",
  type: "product",
  name: "Set of 4 Wood Handle Cheese Knives",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/54599bbf52d79a9d9dce2ce543aad1bb30dc1f47d6d15aa92ebdd8ddcc5c5ef2.jpeg",
  priceDollars: 32,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
